const initialState = {
    loading: false,
    reload: false,
    data: [],
    pmcReregData: [],
    filesRequired: 0,
    // Re-Registration lists:
    open: [],
    closed: [],
};

const ReRegistrationReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_REG_OPEN':
            return {
                ...state,
                open: action.payload,
            };
        case 'SET_REG_CLOSED':
            return {
                ...state,
                closed: action.payload,
            };
        case 'SET_REG_DATA':
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case 'SET_REG_RELOAD':
            return {
                ...state,
                reload: action.payload,
            };
        case 'REG_LOADING':
            return {
                ...state,
                loading: true,
            };
        case 'SET_FILES_REQUIRED':
            return {
                ...state,
                filesRequired: action.payload,
            };
        default:
            return state;
    }
};

export default ReRegistrationReducer;
